import { useTheme } from '../ui/theme.ts';
/** AutoDay's canonical mark; adjacent wordmark supplies its accessible name. */
export function BrandMark({ size = 32 }: { size?: number }) {
  const { palette } = useTheme();
  return <img src={palette === 'original' ? '/brand/autoday-porcelain.svg' : '/brand/autoday.svg'} width={size} height={size} alt="" aria-hidden="true" className="shrink-0" decoding="async" />;
}
